import React, { forwardRef,useEffect, useRef, useState } from "react";
import cx from "classnames";

import { AutosizableInput as BaseAutosizableInput } from "@/ui-lib/FormFields/AutosizableInput";

import styles from "./AutosizableInput.module.scss";

const AutosizableInput = forwardRef(
  (
    {
      value,
      label,
      onChange,
      onBlur,
      onKeyDown,
      placeholder,
      className,
      id,
      inputClassName,
      debouncedTime = 500,
      disabled = false,
      autoFocus = false,
    },
    ref
  ) => {
    const [time, setTime] = useState(null);
    const [buffer, setBuffer] = useState(value);
    const inputRef = useRef();

    useEffect(() => {
      setBuffer(value);
    }, [value]);

    const inputChangeHandler = (event) => {
      const newValue = event.target.value;

      if (time) clearTimeout(time);

      setTime(
        setTimeout(() => {
          onChange(newValue);
        }, debouncedTime)
      );

      setBuffer(newValue);
    };

    const inputBlurHandler = (event) => {
      const newValue = event.target.value;

      if (onBlur) {
        onBlur(newValue);
        setBuffer(newValue);
      }
    };

    const inputKeyDownHandler = (event) => {
      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    return (
      <div className={cx(styles.inputContainer, className)}>
        {label && <label htmlFor={id}>{label}</label>}
        <BaseAutosizableInput
          ref={ref || inputRef}
          placeholder={placeholder}
          inputClassName={inputClassName}
          id={id || ""}
          onChange={inputChangeHandler}
          onBlur={inputBlurHandler}
          onKeyDown={inputKeyDownHandler}
          value={buffer}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      </div>
    );
  }
);

export default AutosizableInput;
